import { useEffect, useState } from "react";

const KEY = "qc_age_verified_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const v = typeof window !== "undefined" ? window.localStorage.getItem(KEY) : "yes";
    if (v !== "yes") setOpen(true);
  }, []);

  const confirm = () => {
    window.localStorage.setItem(KEY, "yes");
    setOpen(false);
  };
  const leave = () => { window.location.href = "https://www.google.com"; };

  if (!open) return null;

  return (
    <div
      data-testid="age-gate-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center px-6"
      style={{ background: "rgba(17,19,25,0.92)", backdropFilter: "blur(14px)" }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
    >
      <div className="max-w-lg w-full grain border border-[#c9a04b]/50 bg-[#1a1c23] p-10 text-center shadow-[0_0_60px_rgba(201,160,75,0.15)]">
        <div className="eyebrow mb-5">Age Restricted</div>
        <h2 id="age-gate-title" className="font-serif text-3xl md:text-4xl text-cream leading-tight mb-4">
          Cross the Threshold
        </h2>
        <p className="text-sm md:text-base text-cream/70 leading-relaxed mb-8">
          This site contains adult themes pertaining to consensual erotic hypnosis.
          You must be eighteen or older - and of legal age in your jurisdiction - to continue.
        </p>
        <div className="gold-divider mb-8" />
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="age-gate-confirm"
            onClick={confirm}
            className="btn-primary w-full sm:w-auto"
          >
            I am 18 or older - Enter
          </button>
          <button
            data-testid="age-gate-leave"
            onClick={leave}
            className="btn-secondary w-full sm:w-auto"
          >
            Leave
          </button>
        </div>
        <p className="mt-7 text-xs text-cream/40 leading-relaxed">
          By entering you accept our Terms, Privacy and Age Verification policies.
        </p>
      </div>
    </div>
  );
}
